export default "__VITE_ASSET__DfbOHgD2__"